import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Container, Paper, Stack } from '@mui/material';
import { useAuthStore } from '../store/auth.store';

export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const { verifyEmail, resendCode, isLoading } = useAuthStore();
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const [email, setEmail] = useState('');
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    const pendingEmail = sessionStorage.getItem('pendingVerificationEmail');
    if (pendingEmail) {
      setEmail(pendingEmail);
    }
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleCodeChange = (index: number, value: string) => {
    if (value.length > 1) value = value[0];
    if (!/^\d*$/.test(value)) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // Auto-focus next input
    if (value && index < 5) {
      const nextInput = document.getElementById(`code-input-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const fullCode = code.join('');
    if (fullCode.length !== 6) {
      alert('Введите полный код');
      return;
    }

    try {
      await verifyEmail(email, fullCode);
      navigate('/dashboard');
    } catch (error) {
      // Error handled in store
    }
  };

  const handleResend = async () => {
    try {
      await resendCode(email);
      setCountdown(60);
    } catch (error) {
      // Error handled in store
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography variant="h4" align="center" gutterBottom>
            Подтверждение Email
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 3 }}>
            Введите 6-значный код, отправленный на {email}
          </Typography>

          <form onSubmit={handleSubmit}>
            <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 3 }}>
              {code.map((digit, index) => (
                <TextField
                  key={index}
                  id={`code-input-${index}`}
                  value={digit}
                  onChange={(e) => handleCodeChange(index, e.target.value)}
                  inputProps={{
                    maxLength: 1,
                    style: { textAlign: 'center', fontSize: '24px' },
                  }}
                  sx={{ width: 60 }}
                />
              ))}
            </Stack>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={isLoading || code.join('').length !== 6}
              sx={{ mb: 2 }}
            >
              {isLoading ? 'Проверка...' : 'Подтвердить'}
            </Button>
          </form>

          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Button
              onClick={handleResend}
              disabled={countdown > 0 || isLoading}
              variant="text"
            >
              {countdown > 0 ? `Отправить повторно (${countdown}с)` : 'Отправить код повторно'}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
